<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=9315-186404&mode=design&t=Nx3UnpINuuqH9918-0 -->
<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?node-id=9315%3A186497&mode=dev -->
<template>
  <div
    class="box"
    :class="wrappClass"
  >
    <div
      v-if="attributes.title"
      class="box__title"
      v-html="attributes.title"
    />
    <div
      v-if="attributes.items"
      ref="boxContent"
      class="box__content"
    >
      <TheContent
        v-for="item of children"
        :key="item.id"
        :elem="item"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { BoxAttributes } from '../../../../types/components/Box';
  import TheContent from '../../TheContent';

  export default defineNuxtComponent({
    name: 'Box',

    components: { TheContent },

    inject: {
      area: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      elem: {
        type: Object as PropType<TContent<BoxAttributes>>,
        required: true,
      },
    },

    computed: {
      getArea(): string {
        // @ts-ignore
        return this.area() ?? '';
      },

      attributes(): BoxAttributes {
        return this.elem.attributes;
      },

      children(): TContent[] {
        return this.elem.children;
      },

      wrappClass(): Record<string, boolean> {
        const areas: Array<string> = [
          'above-comments',
          'below-comments',
          'home',
          'after-first-paragraph',
          'after-third-paragraph',
        ];

        return {
          [`grey-box--${this.getArea}`]: areas.includes(this.getArea),
          'white-box': this.attributes.isWhiteBox,
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .box {
    padding: 24px 16px;
    margin: 24px -16px;
    border: 1px solid #e1eafd;
    border-radius: 2px;
    background: #f3f5fc;

    @include normalText;

    &.white-box {
      margin: 24px auto;
      background: white;
      border-color: #e7e7e7;
    }

    @include tablet {
      @include mediumText;
      padding: 24px;
      margin: 24px 0px;
    }

    &--above-comments,
    &--below-comments,
    &--after-first-paragraph,
    &--after-third-paragraph,
    &--home {
      margin: 0 auto;

      @include tablet {
        padding: 24px;
      }
    }

    &--home {
      margin: 0 16px;
      padding: 24px 16px;
      @include tablet {
        max-width: 828px;
        margin: 0;
        padding: 24px;
      }

      @include big-tablet {
        padding: 24px 28px;
      }

      @include desktop {
        padding: 24px 40px;
      }
    }

    &__title {
      font-family: $secondFont;
      font-weight: 600;
      margin-bottom: 2px;
    }

    a {
      @include linkStyle;
    }

    p:not(:last-child) {
      padding-bottom: 12px;
    }
  }
</style>
